import React from 'react'
import Header from '../../../Components/Header'

function Name() {
    return (
        <div>
            <Header text={"Unit Name"} link={'/datasheet/name'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Name